/* eslint eqeqeq: 'off', react/no-direct-mutation-state: 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup, Label, Table, Modal } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../../../Assets/images/Error.gif';
import '../../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import { closeModalPopUp } from '../../../../../../../action/modalStateAction';
import { GetRegularExpresions } from '../../../../../../../action/EmployeeAction';
import { PostTenantEmployeesDetailsAction, PutTenantEmployeesDetailsAction, CheckIsLogOnNameExists } from '../../../../../../../action/tenantAction';
import DimensionResources from '../../../../../../../Resources/SystemAdmin/SystemAdmin.en-US';
import { sendSingleAmplitudeEvent } from 'amplitude/amplitude';

let Tenant_Zones = [], TenantID = 0, IsEdit = false, LogOnName ="", MismatchErrorText = "Password and the confirmation password should be same.";
let ErrLogOnName=true,ErrFName=true,ErrLName=true,ErrEmail=true,ErrPwd=true,ErrConfirmPwd=true,ErrResetPwd=true,ErrResetConfirmPwd=true;
class AddEmployees extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error_msg: false,
            duplicateerror_msg: false,
            userID: 0,
            SelectedUser: [],
            IsSaveDisabled: false,
            Reset:false,
            ResetError:false,
            IsOktaUser:false,
            ResetPassword:"",
            ErrorDetails : "Error: You left necessary fields blank or entered invalid values.",
            sort: {
                column: null,
                direction: [
                    {name:'zoneName', direction:'asc', onclick:true},
                    {name:'buildingName', direction:'desc', onclick:false},
                    {name:'members', direction:'desc', onclick:false},
                ],
            },
            IsDefaultSort: true,
            IsZoneChkChanged: false,
            SelectedZones: [],
            SelectedTemp: []
        }
        this.CloseModal = this.CloseModal.bind(this);
        this.OpenReset = this.OpenReset.bind(this);
        this.ResetPassword = this.ResetPassword.bind(this);
        this.CancelResetPassword = this.CancelResetPassword.bind(this);
        this.CheckOktaUser = this.CheckOktaUser.bind(this);
    }
    componentWillMount(){
        this.props.GetRegularExpresions();
        Tenant_Zones = this.props.parentToChildData[2];
        TenantID = this.props.parentToChildData[1];
        IsEdit = this.props.parentToChildData[4];
        var UserDts = this.props.parentToChildData[3];
        LogOnName = UserDts[0] != undefined ? UserDts[0].logOnName : "";
        this.setState({userID: this.props.parentToChildData[0], SelectedUser: UserDts[0] });
    }

    OpenReset(){
        this.setState({ Reset:true });
    }

    CancelResetPassword(){
        this.setState({
            Reset:!this.state.Reset,
            ResetPassword:""
        });
    }

    CloseModal(){
        this.setState({
            SelectedUser: [],
            userID: 0
        });
        this.OnClearErrors();
        this.props.closeModalPopUp("close");
    }

    CheckOktaUser(){
        this.setState({
            IsOktaUser:!this.state.IsOktaUser
        }); 
    }

    ResetPassword() {
        MismatchErrorText = "Error: You left necessary fields blank or entered invalid values.";
        this.setState({ResetError: false});
        this.OnClearResetErrors();
        var Password = this.refs.NewPassword.value;
        var ConfirmPassword = this.refs.NewConfirmPassword.value;
        var IsValidUser = true;


        var RegExpPasswordPattern = this.props.getResponse.RegularExpression[1];
        var RegexpPasswordLength = this.props.getResponse.RegularExpression[0];
        var RegexpPasswordDuplicatePattern = /([a-z0-9])\1/i;
        var RegexpPasswordDuplicateAllowed = this.props.getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = this.props.getResponse.RegularExpression[2];

        if (Password == "" || ConfirmPassword == "") {
            IsValidUser = false;
            ErrResetPwd = Password == "" ? false : true;
            ErrResetConfirmPwd = ConfirmPassword == "" ? false : true;

        }
        if (Password != "")
        {
                    if(!Password.match(RegExpPasswordPattern) || !Password.match(RegexpPasswordLength)){
                        IsValidUser = false;
                        ErrResetPwd = false;
                    }
                    else if(RegexpPasswordDuplicateAllowed === "False" && Password.match(RegexpPasswordDuplicatePattern)){                      
                            IsValidUser = false;
                            ErrResetPwd = false;
                            MismatchErrorText = "Invalid Password : Password Cannot Contain Repeating Characters";                    
                    }
                    else if(RegexpPasswordLogOnNameForPasswordAllowed === "False"){
                        if (LogOnName !== "" && Password.toLowerCase().indexOf(LogOnName.toLowerCase()) != -1) {
                            IsValidUser = false;
                            ErrResetPwd = false;
                            MismatchErrorText = "Invalid Password : Password Cannot Contain User ID";
                        }
                    }
        }
        if (Password != "" && ConfirmPassword != "" && Password != ConfirmPassword) {
            IsValidUser = false;
            MismatchErrorText = "Password and the confirmation password should be same.";
            ErrResetPwd = false;
            ErrResetConfirmPwd = false;
        }
        if (IsValidUser) {
            this.setState({
                ResetPassword: Password,
                ResetError: false,
                Reset: !this.state.Reset
            });
        }
        else {
            this.setState({ ResetError: true });
        }
    }

    OnSaveEmployee(Rows){
        this.setState({ error_msg: false, duplicateerror_msg: false, ErrorDetails: "Error: You left necessary fields blank or entered invalid values.", IsSaveDisabled : true });
        this.OnClearErrors();
        var EmployeeList = [];
        var Username="^(([a-zA-Z0-9]|[!#$%&'*+/=?^_`{|}~-])[\\.]?)*([a-zA-Z0-9]+[!#$%&'*+/=?^_`{|}~-]*|[a-zA-Z0-9]*[!#$%&'*+/=?^_`{|}~-]+)[@]{1}([a-zA-Z0-9_-]*([\\.]?[a-zA-Z0-9_]+)+)$";
        var RegExpOnlySpecialCharacters = /^[^a-zA-Z0-9]+$/;
        var RegExpPasswordPattern = this.props.getResponse.RegularExpression[1];
        var RegexpPasswordLength = this.props.getResponse.RegularExpression[0];
        var RegExpLogonNamePattern = this.props.getResponse.RegularExpression[5];
        var RegexpLogonNameLength = this.props.getResponse.RegularExpression[4];
        var RegexpPasswordDuplicatePattern = /([a-z0-9])\1/i;
        var RegexpPasswordDuplicateAllowed = this.props.getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = this.props.getResponse.RegularExpression[2];

      

        var IsValidUser = true;
        var lstZones = [], lstZonesTemp = [];

        if (Rows != undefined && Rows != null && Rows.length) {
            for (let i = 0; i < Rows.length; i++) {
                var id = Rows[i].props.children[3].props.children.ref;
                var Tempid = Rows[i].props.children[4].props.children.ref;
                if (this.refs[id].checked) {
                    lstZones.push(this.refs[id].value);
                    lstZonesTemp.push({"ZoneId":this.refs[Tempid].value, "AllowTemperatureAdjustment": this.refs[Tempid].checked});
                }
            }
        }

        var LogonName = "";
        var FirstName = this.refs.firstName.value;
        var LastName = this.refs.lastName.value;
        var Password = "";
        var ConfirmPassword = "";
        var EmployeeEmail = this.refs.email.value;
        var EmployeePreference = this.refs.displayTemp.options.selectedIndex;
        let isOktaUser = this.state.IsOktaUser;

        if (FirstName == "") {
            IsValidUser = false;
            ErrFName = false;
        }
        if (LastName == "") {
            IsValidUser = false;
            ErrLName = false;
        }
        if(!isOktaUser){
            if (!IsEdit) {
                LogonName = this.refs.userid.value;
                Password = this.refs.password.value;
                ConfirmPassword = this.refs.confirmPassword.value;
           
                if (LogonName == "" || Password == "" || ConfirmPassword == "") {
                    IsValidUser = false;
                    ErrLogOnName = LogonName == "" ? false : true;
                    ErrPwd = Password == "" ? false : true;
                    ErrConfirmPwd = ConfirmPassword == "" ? false : true;
                }
                if(LogonName != "" && !isOktaUser && LogonName.match(RegExpOnlySpecialCharacters)){
                    IsValidUser = false;
                    ErrLogOnName = false;
                }
                if (LogonName != "" && !isOktaUser && (!LogonName.match(RegExpLogonNamePattern) || !LogonName.match(RegexpLogonNameLength))) {
                    IsValidUser = false;
                    ErrLogOnName = false;
                }
                if (Password != "")
                {
                    if(!Password.match(RegExpPasswordPattern) || !Password.match(RegexpPasswordLength)){
                        IsValidUser = false;
                        ErrPwd = false;
                    }
                    else if(RegexpPasswordDuplicateAllowed === "False" && Password.match(RegexpPasswordDuplicatePattern)){                      
                            IsValidUser = false;
                            ErrPwd = false;  
                            this.setState({ErrorDetails:"Invalid Password : Password Cannot Contain Repeating Characters"});                    
                    }
                    else if(RegexpPasswordLogOnNameForPasswordAllowed === "False"){
                        if (LogonName !== "" && Password.toLowerCase().indexOf(LogonName.toLowerCase()) != -1) {
                            IsValidUser = false;
                            ErrPwd = false;
                            this.setState({ErrorDetails:"Invalid Password : Password Cannot Contain User ID"});
                        }
                    }
                }

                if (Password != ConfirmPassword) {
                    IsValidUser = false;
                    ErrPwd = false;
                    ErrConfirmPwd = false;
                    this.setState({ErrorDetails:"Password and the confirmation password should be same."});
                }
            }else{
            LogonName = LogOnName;
            Password = this.state.ResetPassword;
            ConfirmPassword = Password;
            }
        }else{
            if(!IsEdit){
                LogonName = this.refs.userid.value;
                if(LogonName !== "" && LogonName !== null){
                    if(!LogonName.match(Username) || LogonName.match(RegExpOnlySpecialCharacters)){
                        IsValidUser = false;
                        ErrLogOnName = false;
                    }
                }
            }else{
                LogonName = LogOnName; 
            }
        }   

        let lEmployeePreference = this.GetUnitPreferenceNumber(EmployeePreference);
        if(isOktaUser)  
            Password = "";
        EmployeeList.push({ TenantUserId: this.state.userID, TenantId: TenantID, FirstName: FirstName, LastName: LastName, LogOnName: LogonName, Password: Password, IsActive: true, EmployeeEmail: EmployeeEmail, EmployeePreference: EmployeePreference, ZoneIds: lstZones, PreferenceUnits : JSON.stringify(lEmployeePreference), IsTraneConnectUser:isOktaUser
            ,ZonesTemperatureAdjustment: lstZonesTemp});
        if (IsValidUser) {
            if (!IsEdit) {
                const  actionResponse  =  this.props.CheckIsLogOnNameExists(this.refs.userid.value);
                actionResponse.then((result) => {
                    if(!this.props.IsUserIdNameExixts){
                        this.props.PostTenantEmployeesDetailsAction(EmployeeList[0]);                        
                        sendSingleAmplitudeEvent("Create TS Employee User");
                        this.CloseModal();
                    }
                    else
                        this.setState({ duplicateerror_msg: true, IsSaveDisabled: false });
                })
            }else{
                this.props.PutTenantEmployeesDetailsAction(EmployeeList[0]);
                this.CloseModal();
            }
        }else {
            this.setState({ error_msg: true, IsSaveDisabled: false });
        }
    }

    GetUnitPreferenceNumber(a_UnitPreference){
        let l_ReturnValue = [];
        // Get the IP units.
        let l_DimensionIds = DimensionResources.Dimension('EditPreferences.Dimension.Text').split(',');
        if (a_UnitPreference === 0)
        {
            for(let i=0; i < l_DimensionIds.length; i++){
                let l_Key = DimensionResources.Dimension('EnumEditPreferences.cboUnits.IP.'+ l_DimensionIds[i].trim() +'.Text');
                if (l_Key !== undefined) {
                    l_ReturnValue.push({
                        key: Number(l_DimensionIds[i]),
                        value: Number(l_Key.split(',')[0])
                    });
                }
            }
        }
        // Get the SI units.
        if (a_UnitPreference == 1)
        {
            for(let i=0; i < l_DimensionIds.length; i++){
                let l_Key = DimensionResources.Dimension('EnumEditPreferences.cboUnits.SI.'+ l_DimensionIds[i].trim() +'.Text');
                if (l_Key !== undefined) {
                    l_ReturnValue.push({
                        key: Number(l_DimensionIds[i]),
                        value: Number(l_Key.split(',')[0])
                    });
                }
            }
        }
        return l_ReturnValue;
    }

    OnClearErrors(){
        ErrLogOnName=true;
        ErrFName=true;
        ErrLName=true;
        ErrEmail=true;
        ErrPwd=true;
        ErrConfirmPwd=true;
    }

    OnClearResetErrors(){
        ErrResetPwd=true;
        ErrResetConfirmPwd=true;
    }

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort:false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = Tenant_Zones;
        var notequals = 0;
       if(data_from_state != null){
        const sortedData =Tenant_Zones.sort((a, b) => {
            const nameA = (column == 'members') ? a[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? a[column].join(', ').toLowerCase() : a[column].toLowerCase();
            const nameB = (column == 'members') ? b[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? b[column].join(', ').toLowerCase() : b[column].toLowerCase();
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(selected[0].direction =='asc' && notequals == 1){
        sortedData.reverse();
     }
     SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
     SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);
     Tenant_Zones = sortedData;
        this.setState({
            sort: {
                column,
                direction:SortData,
            }
        });
       }
    };

    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };

    OnClickHeaderChk = (HeaderChk, ChildChk, IsZoneChk) => {
        var header_Checkbox = document.getElementsByClassName(HeaderChk);
        var child_checkboxes = document.getElementsByClassName(ChildChk);
        var lstZones = [], lstTemps = [];

        if(child_checkboxes !== undefined && child_checkboxes !== null && child_checkboxes.length){
            if(header_Checkbox[0].checked){
                if(IsZoneChk) 
                    lstZones = Array.from(child_checkboxes).map(elem => elem.value);
                else
                    lstTemps = Array.from(child_checkboxes).map(elem => elem.value);
            }
        }

        if(IsZoneChk){
            lstTemps = this.state.SelectedTemp;
            if(!header_Checkbox[0].checked){
                lstTemps = [];
                this.refs.ref_TempHeader_chk.checked = false;
            }
            this.setState({ IsZoneChkChanged : true, SelectedZones : lstZones, SelectedTemp : lstTemps });
        }else{
            this.setState({ IsZoneChkChanged : true, SelectedTemp : lstTemps });
        }
    }

    OnClickChildChk = (HeaderChk, ChildChk, IsZoneChk) => {
        var lstZones = [], lstTemps = [];
        var ZoneChildChks = Array.from(document.getElementsByClassName(ChildChk)).filter(el => el.disabled === false);
        if(IsZoneChk){
            var lst_Zones = Array.from(ZoneChildChks).map(elem => { return elem.checked ? elem.value : ""});
            lstZones = (lst_Zones !== undefined && lst_Zones !== null && lst_Zones.length) ? lst_Zones.filter(el => el !== "") : [];
            if(ZoneChildChks.length !== lstZones.length) this.refs.ref_TempHeader_chk.checked = false;
            
            var TempData = this.state.SelectedTemp;
            TempData !== undefined && TempData !== null && TempData.length && TempData.forEach(el1 =>{
                if(lstZones.some((el2) => el2.toString() === el1.toString())){
                    lstTemps.push(el1);
                }
            })

            this.setState({ IsZoneChkChanged : true, SelectedZones : lstZones, SelectedTemp : lstTemps });
        }else{
            var lst_Temps = ZoneChildChks.map(elem => { return elem.checked ? elem.value : ""});
            lstTemps = (lst_Temps !== undefined && lst_Temps !== null && lst_Temps.length) ? lst_Temps.filter(el => el !== "") : [];
            this.refs.ref_TempHeader_chk.checked =  (ZoneChildChks.length === lstTemps.length) ? true : false;
            this.setState({ IsZoneChkChanged : true, SelectedTemp : lstTemps });
        }        
    }

    render(getResponse, IsUserIdNameExixts) {
        //var CloseModal = this.props.CloseModal;
        let modal_form = null, Error_Message, DuplicateError_Message, MismatchError_Message,  Password_fields, Header_Text, Assigned_Zones, LogOnName, IsAllChecked = true, IsTempAllChecked = true, enableTempHeader = false;
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> {this.state.ErrorDetails}</p> : Error_Message = " ";
        DuplicateError_Message = this.state.duplicateerror_msg ? <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  Error: Duplicate Login Name.</p> : " ";
        MismatchError_Message = this.state.ResetError ? <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {MismatchErrorText}</p> : " ";

        var ViewUserInfo = this.state.SelectedUser;
        var view_logonname = '', view_FirstName = '', view_LastName = '', view_Email = '', view_EmpPreference = 0, view_ZoneIds = [], view_TempZoneIds = [];
        if (ViewUserInfo != undefined && ViewUserInfo != null) {
            view_logonname = ViewUserInfo.logOnName;
            view_FirstName = ViewUserInfo.firstName;
            view_LastName = ViewUserInfo.lastName;
            view_Email = ViewUserInfo.employeeEmail;
            view_EmpPreference = ViewUserInfo.employeePreference;
            if(!this.state.IsZoneChkChanged){
                view_ZoneIds = ViewUserInfo.zoneIds;
                if(ViewUserInfo.zonesTemperatureAdjustment !== undefined && ViewUserInfo.zonesTemperatureAdjustment !== null && ViewUserInfo.zonesTemperatureAdjustment.length){
                    view_TempZoneIds = ViewUserInfo.zonesTemperatureAdjustment.filter(x => x.allowTemperatureAdjustment === true).map(el => el.zoneId);    
                }
            
                this.state.SelectedZones = view_ZoneIds;
                this.state.SelectedTemp = view_TempZoneIds;
            }
            this.state.IsOktaUser = ViewUserInfo.isTraneConnectUser;
        }
        if(this.state.IsZoneChkChanged){
            view_ZoneIds = this.state.SelectedZones;
            view_TempZoneIds = this.state.SelectedTemp;
        }

        if(Tenant_Zones !== undefined && Tenant_Zones !== null && Tenant_Zones.length ){
            if(this.state.IsDefaultSort){
                Tenant_Zones.sort((a,b)=>{
                    let nameA = a['zoneName'].toLowerCase();
                    let nameB = b['zoneName'].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });
            }
            Assigned_Zones = Tenant_Zones.map(el => {
                var HasChecked = view_ZoneIds != undefined && view_ZoneIds != "" ? view_ZoneIds.filter(ele => ele == el.zoneId).length > 0 : false;
                if(!HasChecked) IsAllChecked = false;
                var HasTempChecked = view_TempZoneIds !== undefined && view_TempZoneIds !== "" ? view_TempZoneIds.filter(ele => ele == el.zoneId).length > 0 : false;
                if(!HasTempChecked) IsTempAllChecked = false;
                var IsSingleMemberZone = false;
                if(el.members !== null && el.members.length){
                    var ObjectCount = el.members.filter(ele => ele.objectType !== 4 && ele.objectType !== 5).length;
                    IsSingleMemberZone = ObjectCount === 1 ? true : false;
                }
                if(HasChecked && IsSingleMemberZone){
                    enableTempHeader = true;
                }
                return <tr>
                    <td>{el.zoneName}</td>
                    <td>{el.buildingName}</td>
                    <td>{el.members.map(xl => (xl.objectName)).join(', ')}</td>
                    <td><input type="checkbox" checked={HasChecked} ref={'ref_' + el.zoneId} value={el.zoneId} className="TenantZones1_child_Check_box" onClick={() => { this.OnClickChildChk("TenantZones1_header_Check_box", "TenantZones1_child_Check_box", true); }}/></td>
                    <td><input type="checkbox" checked={HasTempChecked && HasChecked && IsSingleMemberZone} disabled={!HasChecked || !IsSingleMemberZone} ref={'ref_Temp_' + el.zoneId} value={el.zoneId} className="ZonesTemp_child_Check_box" onClick={() => { this.OnClickChildChk("ZonesTemp_header_Check_box", "ZonesTemp_child_Check_box", false); }}/></td>
                </tr>
            });
        }else{
            Assigned_Zones = <tr> <td colSpan={4}>No Records Found</td> </tr>
            IsAllChecked = false;
            IsTempAllChecked = false;
        }
        if(!this.state.IsOktaUser){
                if (this.state.userID > 0) {
                    Password_fields = <div className="form_group_modal">
                        <Label className="Custom_label"> Password*</Label>
                        <Label id='lbl_Emp_ResetPwd' onClick={this.OpenReset} style={{ color: '#6890C6' }}>Reset</Label>
                    </div>
                    Header_Text = "Edit Tenant Employee";
                    LogOnName = <div><p ref='useridlbl' style={{"overflow-wrap":"break-word"}}>{view_logonname}</p></div>
                }
                else {
                    Password_fields = <div><div className="form_group_modal">
                        <Label className="Custom_label"> Password*</Label>
                        <input ref='password' id='txt_Emp_Pwd' type="password" className="custom_input default-input" />
                        <span className="ErrorMark" hidden={ErrPwd} >!</span>
                        </div>
                        <div className="form_group_modal">
                            <Label className="Custom_label">Confirm Password*</Label>
                            <input ref='confirmPassword' id='txt_Emp_ConfirmPwd' type="password" className="custom_input default-input" />
                            <span className="ErrorMark" hidden={ErrConfirmPwd} >!</span>
                        </div>
                    </div>
                    Header_Text = "Add Tenant Employee";
                    LogOnName = <div><input ref='userid' id='txt_Emp_LogonName' className="custom_input default-input" defaultValue={view_logonname} maxLength="320" /><span className="ErrorMark" hidden={ErrLogOnName} >!</span></div>
                }
        }else{
                if (this.state.userID > 0) {
                    Password_fields = <div className="form_group_modal">
                        <Label className="Custom_label"> Password*</Label>
                        <Label style={{ color: '#6890C6' }}>Reset</Label>
                    </div>
                    Header_Text = "Edit Tenant Employee";
                    LogOnName = <Label ref='useridlbl' className="Custom_label">{view_logonname}</Label>
                }
                else{
                Password_fields = <div><div className="form_group_modal">
                <Label className="Custom_label"> Password*</Label>
                <input ref='password' id='txt_Emp_Pwd' type="password" className="custom_input default-input" disabled="true"/>
                </div>
                <div className="form_group_modal">
                    <Label className="Custom_label">Confirm Password*</Label>
                    <input ref='confirmPassword' id='txt_Emp_ConfirmPwd' type="password" className="custom_input default-input" disabled="true" />
                </div>
                </div>  
                Header_Text = "Add Tenant Employee";
                LogOnName = <div><input ref='userid' id='txt_Emp_LogonName' className="custom_input default-input" defaultValue={view_logonname} /><span className="ErrorMark" hidden={ErrLogOnName} >!</span></div>
            }
        }

        modal_form = <div>
            <h7 className="form_sub_title padding_Form_Left">{Header_Text}</h7>
            <br />
            <br />
            <Label className="padding_Form_Left">Enter information to uniquely identify an employee for after hours requests. Select which subgroup(s) and zone(s) the employee can make requests for. </Label>
            {Error_Message}
            {DuplicateError_Message}
            <legend className="form_sub_title padding_Form_Left">Employee Information</legend>

             {/* <div className="form_group_modal ">
                 <FormGroup check >
                 {(!IsEdit) ?
                     <Label check>
                      <Input type="checkbox" checked={this.state.IsOktaUser} onClick={this.CheckOktaUser} style={{marginTop:(this.props.OnPremises) ? "0px": {}}}/>Is Okta User
                     </Label> : ""}
                 </FormGroup>
             </div> */}

            <div className="form_group_modal ">
                <Label className="Custom_label">User ID*</Label>
                {LogOnName}
            </div>
            <div className="form_group_modal">
                <Label className="Custom_label">First Name*</Label>
                <input ref='firstName' id='txt_Emp_FName' className="custom_input default-input" defaultValue={view_FirstName} />
                <span className="ErrorMark" hidden={ErrFName} >!</span>
            </div>

            <div className="form_group_modal">
                <Label className="Custom_label">Last Name*</Label>
                <input ref='lastName' id='txt_Emp_LName' className="custom_input default-input" defaultValue={view_LastName} />
                <span className="ErrorMark" hidden={ErrLName} >!</span>
            </div>

            <div className="form_group_modal">
                <Label className="Custom_label"> E-mail Address</Label>
                <input ref='email' id='txt_Emp_Email' className="custom_input default-input" defaultValue={view_Email} />
                <span className="ErrorMark" hidden={ErrEmail} >!</span>
            </div>

            <div className="form_group_modal form_odd_div">
                <Label className="Right_Aligned_Label">Required for employees that need to receive Facility Request e-mail confirmations</Label>
            </div>
             {Password_fields}  
            <div className="form_group_modal ">
                <Label className="Custom_label_small_width">Display Temperatures in</Label>
                <select ref='displayTemp' id='rdl_Emp_Temp' defaultValue={view_EmpPreference} className="custom_input default-input " >
                    <option value="0">Degrees Fahrenheit</option>
                    <option value="1">Degrees Celsius</option>
                </select>
            </div>
            <br />
            
            <div className="form_group_modal" style={{"padding-bottom":"0px", "margin-bottom": "0px"}}>
                <span style={{"font-weight": "bold",  "line-height" : "20px", "font-size": "14px"}}>Zone Access and Temperature Adjustment Permissions</span>
                <br/>
                <span style={{"font-size": "13px"}}>{"Temperature access can’t be granted unless Zone access is granted. Temperature can be enabled only if the zone has a single space or area."}</span>
            </div>
            <div className="form_group_modal">
            <div style={{ width: '100%', overflowY: 'auto', maxHeight: '280px' }}>
                <Table striped responsive className="Custom_table table_border" id='tbl_Emp_Zones'>
                    <tbody className="cell_container tenant_cell">
                        <tr>
                            <th style={{ width: '20%' }} onClick={this.onSort('zoneName')}>Zone<span className={this.setArrow('zoneName')}></span></th>
                            <th style={{ width: '20%' }} onClick={this.onSort('buildingName')}>Building<span className={this.setArrow('buildingName')}></span></th>
                            <th style={{ width: '20%' }} onClick={this.onSort('members')}>Members<span className={this.setArrow('members')}></span></th>
                            <th style={{ width: '8%' }}><input type="checkbox" className="TenantZones1_header_Check_box" style={{"margin-right" : "5px"}} ref="ref_ZoneHeader_chk" checked={IsAllChecked} onClick={() => { this.OnClickHeaderChk("TenantZones1_header_Check_box", "TenantZones1_child_Check_box", true); }} />Zone</th>
                            <th style={{ width: '13%' }}><input type="checkbox" defaultChecked={IsTempAllChecked} disabled={!enableTempHeader} className="ZonesTemp_header_Check_box" style={{"margin-right" : "5px"}} ref="ref_TempHeader_chk" onClick={() => { this.OnClickHeaderChk("ZonesTemp_header_Check_box", "ZonesTemp_child_Check_box", false); }} />Temperature</th>
                        </tr>
                        {Assigned_Zones}
                    </tbody>
                </Table>
            </div>
            </div>
            <FormGroup row className="btns_group">
                <Col sm={{ size: 10 }}>
                    <Button className="btn-gray btn-md" onClick={this.CloseModal} > Cancel </Button>
                    <Button className="btn-success btn-md" disabled={this.state.IsSaveDisabled} onClick={() => { this.OnSaveEmployee(Assigned_Zones)}}> Done </Button>
                </Col>
            </FormGroup>
        </div>

        return (<div> {modal_form} 
            <Modal isOpen={this.state.Reset} zIndex = "2147483646" className={this.props.className}>
                <div>
                    <h4 className="form_title">Reset Employee Password</h4>
                    {MismatchError_Message}
                    <div className="form_group_modal">
                        <Label className="Custom_label">New Password*</Label>
                        <input ref='NewPassword' id='txt_NewPwd' type="password" className="custom_input default-input" />
                        <span className="ErrorMark" hidden={ErrResetPwd} >!</span>
                    </div>

                    <div className="form_group_modal">
                        <Label className="Custom_label">Confirm Password*</Label>
                        <input ref='NewConfirmPassword' id='txt_confirmPwd' type="password" className="custom_input default-input" />
                        <span className="ErrorMark" hidden={ErrResetConfirmPwd} >!</span>
                    </div>

                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-gray btn-md" id='btn_Pwd_Cancel' onClick={this.CancelResetPassword} > Cancel </Button>
                            <Button className="btn-success btn-md" id='btn_Pwd_Reset' onClick={this.ResetPassword}  > Save </Button>
                        </Col>
                    </FormGroup>
                </div>
            </Modal>
        </div>);
    }
}
const mapStateToProps = state => {
    return {
        getResponse: state.EmployeeRootReducer,
        IsUserIdNameExixts: state.ViewtenantsRootReducer.IsLogOnNameExists,
        OnPremises: state.authService.IsOnPremise
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetRegularExpresions: () => dispatch(GetRegularExpresions()),
        PostTenantEmployeesDetailsAction: (data) => dispatch(PostTenantEmployeesDetailsAction(data)),
        PutTenantEmployeesDetailsAction: (data) => dispatch(PutTenantEmployeesDetailsAction(data)),
        CheckIsLogOnNameExists: (name) => dispatch(CheckIsLogOnNameExists(name)),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddEmployees);